import { useEffect, useState } from 'react'
const useZoomAwareBreakpoints = (
  minWidth: number,
  defaultMatches: boolean = true
) => {
  const [matches, setMatches] = useState(defaultMatches)

  useEffect(() => {
    const checkScreenSize = () => {
      const isZoomed =
        window.outerWidth &&
        window.innerWidth &&
        window.outerWidth / window.innerWidth > 1.1

      const screenWidth = window.screen.width
      const viewportWidth = window.innerWidth

      const effectiveWidth = isZoomed
        ? screenWidth
        : viewportWidth < 800
          ? viewportWidth
          : screenWidth

      setMatches(effectiveWidth >= minWidth)
    }

    checkScreenSize()

    window.addEventListener('resize', checkScreenSize)
    window.addEventListener('orientationchange', checkScreenSize)

    // Use MutationObserver to detect when dev tools modifies the viewport
    const observer = new MutationObserver(checkScreenSize)
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
    })

    return () => {
      window.removeEventListener('resize', checkScreenSize)
      window.removeEventListener('orientationchange', checkScreenSize)
      observer.disconnect()
    }
  }, [minWidth])

  return matches
}
export default useZoomAwareBreakpoints
